export const MESSAGE_ADD_LESSON_SUCCESS = '학습 목표를 추가했습니다.';
export const MESSAGE_REMOVE_LESSON_SUCCESS = 'LESSON을 삭제했습니다.';
export const MESSAGE_ADD_ATTACHMENT_SUCCESS = '첨부파일을 추가했습니다.';



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/shared/lesson-message.ts